
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7Bwbp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l998X = parcelRequire("l998X");





var $bYRk6 = parcelRequire("bYRk6");


var $dh538 = parcelRequire("dh538");


var $hnvzE = parcelRequire("hnvzE");


var $gWF6I = parcelRequire("gWF6I");


var $8pzEG = parcelRequire("8pzEG");


var $eoBBJ = parcelRequire("eoBBJ");


var $dv2kx = parcelRequire("dv2kx");


var $gBjFV = parcelRequire("gBjFV");


var $h0D5V = parcelRequire("h0D5V");











var $ecqMk = parcelRequire("ecqMk");


var $fVYKU = parcelRequire("fVYKU");


var $4iq9P = parcelRequire("4iq9P");


var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


var $1KCEa = parcelRequire("1KCEa");


const $3436042677ac723e$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("5ncWi")), {
        moduleId: "9dc17d8c",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-to-premium-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardToPremiumModalQuery: {
                    parameters: $1KCEa.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});


function $4ec6a5a2e949e03a$export$a74acc125b20e3e5() {
    const { product: product, cloudId: cloudId } = (0, $eoBBJ.useEditionAwareness)();
    const entryPointParams = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $ecqMk.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const modalProps = (0, $42omo.useMemo)(()=>({
            width: 968
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVYKU.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $3436042677ac723e$export$6333901e831d7af0),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $4iq9P.DIALOG_CONFIG)
    });
}



var $04kvJ = parcelRequire("04kvJ");


var $hT0Mj = parcelRequire("hT0Mj");

/**
 * This is a required action in context, just not used in the upsell modal
 */ function $f657b254310c6ca7$var$startCheckingForAttemptToUpgrade() {
    return new Promise((resolve)=>resolve(false));
}
/**
 * Edition awareness upsell is an experimental EA implementtiona that has to be exported as its own component to avoid making ccp calls which are alerting VC90 mertics
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $f657b254310c6ca7$var$EditionAwarenessUpsellImpl({ edition: edition, product: product, cloudId: cloudId, userRoles: userRoles, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton, navVersion: navVersion, originalProjectTypeWasCore: originalProjectTypeWasCore }) {
    const trialOfferingName = (0, $gBjFV.getTrialOfferingName)(product, edition);
    const context = (0, $42omo.useMemo)(()=>{
        return {
            cloudId: cloudId,
            product: product,
            edition: edition,
            userRoles: userRoles,
            hasDismissedButton: hasDismissedButton,
            onDismissButton: onDismissButton,
            trialOfferingName: trialOfferingName,
            // This is not used in this flow, but a required type in context
            licensedUsers: 1,
            // This is displayed to sites that are on not trial not predunning
            invoiceableStatus: 'INVOICEABLE',
            startCheckingForAttemptToUpgrade: $f657b254310c6ca7$var$startCheckingForAttemptToUpgrade,
            hasDialogAutoOpened () {
                // Require for context, not used in the modal
                return true;
            },
            originalProjectTypeWasCore: originalProjectTypeWasCore
        };
    }, [
        cloudId,
        product,
        edition,
        userRoles,
        hasDismissedButton,
        onDismissButton,
        trialOfferingName,
        originalProjectTypeWasCore
    ]);
    const experimentContextValue = (0, $42omo.useMemo)(()=>new (0, $dv2kx.ExperimentContextClass)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dv2kx.ExperimentContext).Provider, {
        value: experimentContextValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eoBBJ.EditionAwarenessContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                data: {
                    navVersion: navVersion,
                    hasDismissedButton: hasDismissedButton
                },
                children: (0, $dh538.fg)('remove-spotlight-edition-awareness-fg') ? /*#__PURE__*/ (0, $l998X.jsx)($f657b254310c6ca7$var$StandardEdition, {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $hT0Mj.Spotlights), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)($f657b254310c6ca7$var$StandardEdition, {})
                })
            })
        })
    });
}
function $f657b254310c6ca7$export$148b30c5d238daaa(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "edition-awareness-upsell",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $04kvJ.ErrorBoundary), {
                product: product,
                edition: edition,
                id: "edition-awareness-upsell",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $l998X.jsx)($f657b254310c6ca7$var$EditionAwarenessUpsellImpl, {
                        ...props
                    })
                })
            })
        })
    });
}
function $f657b254310c6ca7$var$StandardEdition() {
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { product: product, hasDismissedButton: hasDismissedButton, originalProjectTypeWasCore: originalProjectTypeWasCore } = context;
    const { getExperimentValue: getExperimentValue, getExperimentValueWithTransform: getExperimentValueWithTransform } = (0, $dv2kx.useGetExperimentValue)();
    if ((0, $h0D5V.isEligibleForStandardToPremium)(context) && !hasDismissedButton) {
        // Firing exposure for the introduction of full JWM support
        if (product === 'jira' && originalProjectTypeWasCore && getExperimentValue({
            statsigParams: {
                experimentName: 'twcg-1563-remove-jira-only-restriction',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) !== 'variation') // If the tenant is not in variation, we don't show anything, as that is the original JWM experience
        return null;
        let experimentKey;
        if (product === 'confluence') experimentKey = 'edition_awareness_standard_upsell_confluence_ab';
        else if (product === 'jira-product-discovery') experimentKey = 'edition_awareness_upsell_jpd';
        else experimentKey = 'edition_awareness_upsell_jira_ab';
        const cohort = getExperimentValueWithTransform({
            statsigParams: {
                experimentName: experimentKey,
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            transformCohortFunc: (0, $dv2kx.treatmentCohortTransformFn)
        });
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                cohort === 'control' && /*#__PURE__*/ (0, $l998X.jsx)((0, $8pzEG.FeatureExposedAnalytics), {
                    flagKey: experimentKey,
                    cohort: cohort
                }),
                cohort === 'treatment' && /*#__PURE__*/ (0, $l998X.jsx)((0, $8pzEG.FeatureExposedAnalytics), {
                    flagKey: experimentKey,
                    cohort: cohort,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4ec6a5a2e949e03a$export$a74acc125b20e3e5), {})
                })
            ]
        });
    }
    return null;
}



var $aT8im = parcelRequire("aT8im");

const $c3bfeb8f0718102a$export$148b30c5d238daaa = ({ navVersion: navVersion })=>{
    const { isEligibleForUpsellExperiment: isEligibleForUpsellExperiment, ...rest } = (0, $aT8im.useConfluenceStandardToPremiumExperiment)();
    if (isEligibleForUpsellExperiment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f657b254310c6ca7$export$148b30c5d238daaa), {
        navVersion: navVersion,
        ...rest
    });
    return null;
};
module.exports["EditionAwarenessUpsell"] = $c3bfeb8f0718102a$export$148b30c5d238daaa;

});

parcelRegister("8pzEG", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ac7kz = parcelRequire("ac7kz");

function $12c853e475c615c0$export$b12ce465f015026c({ flagKey: flagKey, cohort: cohort, growthInitiative: growthInitiative, attributes: attributes, children: children }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const hasSent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        flagKey,
        cohort,
        growthInitiative,
        attributes
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
}
const $12c853e475c615c0$export$5218ddb3d9c658c0 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const sentFlagKeys = (0, $42omo.useRef)([]);
    const fireExperimentExposureEvent = (0, $42omo.useCallback)((flagKey, cohort, growthInitiative, attributes)=>{
        if (sentFlagKeys.current.includes(flagKey)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        sentFlagKeys.current.push(flagKey);
    }, [
        sendAnalyticsEvent
    ]);
    return fireExperimentExposureEvent;
};
module.exports["FeatureExposedAnalytics"] = $12c853e475c615c0$export$b12ce465f015026c;
module.exports["useFeatureExposedAnalytics"] = $12c853e475c615c0$export$5218ddb3d9c658c0;

});

parcelRegister("ac7kz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $6v6KC = parcelRequire("6v6KC");

var $inPa6 = parcelRequire("inPa6");


var $eoBBJ = parcelRequire("eoBBJ");


var $dv2kx = parcelRequire("dv2kx");

const $2a8aa1aaafc441a7$export$85183a312807388d = (0, $3pfAb.FabricChannel).growth;
const $2a8aa1aaafc441a7$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $2a8aa1aaafc441a7$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-awareness',
    source: 'editionAwareness',
    featureId: 'edition-awareness',
    growthPillar: 'BUY'
};
function $2a8aa1aaafc441a7$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const editionAwarenessContext = (0, $eoBBJ.useEditionAwareness)();
    const experimentContext = (0, $dv2kx.useExperimentContext)();
    const sendAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        const editionAwarenessContextAttributes = {
            // Required properties
            cloudId: editionAwarenessContext.cloudId,
            product: editionAwarenessContext.product,
            currentProductEdition: editionAwarenessContext.edition,
            // Payment properties
            isInvoiceable: editionAwarenessContext.invoiceableStatus === 'INVOICEABLE' ? true : editionAwarenessContext.invoiceableStatus === 'NOT_INVOICEABLE' ? false : null,
            hasPaymentDetailsEntered: editionAwarenessContext.hasPaymentDetailsEntered,
            canAddPaymentDetails: editionAwarenessContext.canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: editionAwarenessContext.addPaymentDetailsExperienceUrl,
            // Trial properties
            trialDaysLeft: editionAwarenessContext.trialDaysLeft,
            trialLengthDays: editionAwarenessContext.trialLengthDays,
            trialEndDate: editionAwarenessContext.trialEndDate,
            isInTrial: editionAwarenessContext.isInTrial,
            isInPredunning: editionAwarenessContext.isInPredunning,
            isInReverseTrial: editionAwarenessContext.isInReverseTrial,
            trialOfferingName: editionAwarenessContext.trialOfferingName,
            lastKnownTrial: editionAwarenessContext?.lastKnownTrial,
            offeringKey: editionAwarenessContext?.offeringKey,
            // Upgrade properties
            canUpgrade: editionAwarenessContext.canUpgrade,
            changeOfferingToStandardExperienceUrl: editionAwarenessContext.changeOfferingToStandardExperienceUrl,
            directBuyChangeOfferingToStandardExperienceUrl: editionAwarenessContext.directBuyChangeOfferingToStandardExperienceUrl,
            // Entitlement properties
            entitlementId: editionAwarenessContext.entitlementId,
            isInCollection: editionAwarenessContext.isInCollection,
            collectionType: editionAwarenessContext.collectionType,
            // User permissions properties
            userRoles: editionAwarenessContext.userRoles,
            userEmail: editionAwarenessContext.userEmail,
            // Site properties
            billingSourceSystem: editionAwarenessContext.hasDismissedButton === false ? null : 'CCP',
            licensedUsers: editionAwarenessContext.licensedUsers,
            storageUsageInGB: editionAwarenessContext.storageUsageInGB,
            isEnterpriseCustomer: editionAwarenessContext.isEnterpriseCustomer,
            // Site traits
            automationUsage: editionAwarenessContext.automationUsage,
            lastAutomationFreeLimitBreachDate: editionAwarenessContext.lastAutomationFreeLimitBreachDate,
            automationFreeLimitStatus: editionAwarenessContext.automationFreeLimitStatus,
            // Capabilities
            shouldAutoOpen: editionAwarenessContext.shouldAutoOpen,
            // For twcg-1563 experiment, temporary attribute for the introduction of full JWM support
            originalProjectTypeWasCore: editionAwarenessContext.originalProjectTypeWasCore
        };
        if (payload instanceof (0, $6v6KC.default)) {
            const contextAttributes = $2a8aa1aaafc441a7$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...$2a8aa1aaafc441a7$export$38cd8db2db178f58,
                    ...payload.payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experiments: experimentContext.experiments()
                }
            }).fire($2a8aa1aaafc441a7$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...$2a8aa1aaafc441a7$export$38cd8db2db178f58,
                    ...payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experiments: experimentContext.experiments()
                }
            });
            const contextAttributes = $2a8aa1aaafc441a7$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($2a8aa1aaafc441a7$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent,
        editionAwarenessContext,
        experimentContext
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
}
function $2a8aa1aaafc441a7$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = $2a8aa1aaafc441a7$export$e955abb82869dc84();
    const hasSent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        name,
        attributes
    ]);
    return null;
}
module.exports["ANALYTICS_CHANNEL"] = $2a8aa1aaafc441a7$export$85183a312807388d;
module.exports["getAttributesFromContexts"] = $2a8aa1aaafc441a7$export$d97c97ed77ff09e8;
module.exports["defaultAttributes"] = $2a8aa1aaafc441a7$export$38cd8db2db178f58;
module.exports["useAnalytics"] = $2a8aa1aaafc441a7$export$e955abb82869dc84;

});

parcelRegister("eoBBJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e386a7914d299870$export$ac3ca8c46f19a73f = /*#__PURE__*/ (0, $42omo.createContext)(null);
function $e386a7914d299870$export$5a5baedfe8151ce() {
    const context = (0, $42omo.useContext)($e386a7914d299870$export$ac3ca8c46f19a73f);
    if (!context) throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
    return context;
}
module.exports["EditionAwarenessContext"] = $e386a7914d299870$export$ac3ca8c46f19a73f;
module.exports["useEditionAwareness"] = $e386a7914d299870$export$5a5baedfe8151ce;

});

parcelRegister("dv2kx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $8pzEG = parcelRequire("8pzEG");

class $c27b0540064e1768$export$cab0526cd5428d4e {
    experimentExposed(experimentName, experimentVariant, extraAttributes) {
        // If the experiment is already in the dictionary (i.e. been exposed before),
        // we don't want to overwrite the timestamp of first exposure.
        if (Object.keys(this.experimentDictionary).includes(experimentName)) return;
        this.experimentDictionary[experimentName] = {
            cohort: experimentVariant,
            timestamp: Date.now(),
            ...extraAttributes
        };
    }
    experiments() {
        return this.experimentDictionary;
    }
    constructor(context){
        this.experimentDictionary = {};
        this.experimentDictionary = context ?? {};
    }
}
const $c27b0540064e1768$export$fcdf652c4fd8e4c7 = /*#__PURE__*/ (0, $42omo.createContext)(null);
function $c27b0540064e1768$export$471c3c65727643de() {
    const context = (0, $42omo.useContext)($c27b0540064e1768$export$fcdf652c4fd8e4c7);
    if (!context) throw new Error('Missing context, please ensure this is used within ExperimentContext');
    return context;
}
const $c27b0540064e1768$export$259da07bf82c42c7 = (parameterValue)=>parameterValue ? 'variation' : 'control';
const $c27b0540064e1768$export$f2497ad79c72045c = (cohort)=>{
    if (cohort === 'treatment') return 'variation';
    else if (cohort === 'control') return 'control';
    else return 'not-enrolled';
};
const $c27b0540064e1768$export$59dd27b2c85d98d8 = ()=>{
    const experimentContext = $c27b0540064e1768$export$471c3c65727643de();
    const fireExperimentExposureEvent = (0, $8pzEG.useFeatureExposedAnalytics)();
    const getExperimentValue = (0, $42omo.useCallback)(({ statsigParams: { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options }, trackEventParameters: trackEventParameters, experimentContextAttributes: experimentContextAttributes = {} })=>{
        const cohort = options ? (0, $c6GJD.default).getExperimentValue(experimentName, parameterName, defaultValue, options) : (0, $c6GJD.default).getExperimentValue(experimentName, parameterName, defaultValue);
        // By default, fireExperimentExposure is true but we need to explicitly
        // check for that to ensure we fire our context update correctly.
        if (options?.fireExperimentExposure !== false) {
            experimentContext.experimentExposed(experimentName, cohort, experimentContextAttributes);
            if (trackEventParameters) fireExperimentExposureEvent(experimentName, cohort, trackEventParameters?.trackEventGrowthInitiative, trackEventParameters?.trackEventAttributes);
        }
        return cohort;
    }, [
        experimentContext,
        fireExperimentExposureEvent
    ]);
    /**
   * @deprecated Use getExperimentValue instead with the correct experiment cohort values.
   * We are moving towards consistent cohort values of 'control', 'variation' and 'not-enrolled'.
   */ const getExperimentValueWithTransform = (0, $42omo.useCallback)(({ statsigParams: { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options }, transformCohortFunc: transformCohortFunc, trackEventParameters: trackEventParameters, experimentContextAttributes: experimentContextAttributes = {} })=>{
        const cohort = options ? (0, $c6GJD.default).getExperimentValue(experimentName, parameterName, defaultValue, options) : (0, $c6GJD.default).getExperimentValue(experimentName, parameterName, defaultValue);
        // By default, fireExperimentExposure is true but we need to explicitly
        // check for that to ensure we fire our context update correctly.
        if (options?.fireExperimentExposure !== false) {
            experimentContext.experimentExposed(experimentName, transformCohortFunc(cohort), experimentContextAttributes);
            if (trackEventParameters && typeof cohort === 'string') fireExperimentExposureEvent(experimentName, cohort, trackEventParameters?.trackEventGrowthInitiative, trackEventParameters?.trackEventAttributes);
        }
        return cohort;
    }, [
        experimentContext,
        fireExperimentExposureEvent
    ]);
    return {
        getExperimentValue: getExperimentValue,
        getExperimentValueWithTransform: getExperimentValueWithTransform
    };
};
module.exports["ExperimentContextClass"] = $c27b0540064e1768$export$cab0526cd5428d4e;
module.exports["ExperimentContext"] = $c27b0540064e1768$export$fcdf652c4fd8e4c7;
module.exports["useExperimentContext"] = $c27b0540064e1768$export$471c3c65727643de;
module.exports["treatmentCohortTransformFn"] = $c27b0540064e1768$export$f2497ad79c72045c;
module.exports["useGetExperimentValue"] = $c27b0540064e1768$export$59dd27b2c85d98d8;

});

parcelRegister("4iq9P", function(module, exports) {

var $go59p = parcelRequire("go59p");

const $d26929c1060eb9d8$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'standard-to-premium-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $go59p.Edition).PREMIUM_EDITION
};
module.exports["DIALOG_CONFIG"] = $d26929c1060eb9d8$export$3b6761b6086f6dfd;

});

parcelRegister("go59p", function(module, exports) {
var $99a16ca2a3e56985$export$9874ba4d5a9c06c8 = /*#__PURE__*/ function(GrowthPillar) {
    GrowthPillar["FIND"] = "FIND";
    GrowthPillar["BUY"] = "BUY";
    GrowthPillar["USE"] = "USE";
    GrowthPillar["PLATFORM"] = "PLATFORM";
    return GrowthPillar;
}({});
var $99a16ca2a3e56985$export$6f4a0f769e61929 = /*#__PURE__*/ function(Edition) {
    Edition["FREE_EDITION"] = "free";
    Edition["STANDARD_EDITION"] = "standard";
    Edition["PREMIUM_EDITION"] = "premium";
    Edition["SELECTION"] = "selection";
    return Edition;
}({});
module.exports["Edition"] = $99a16ca2a3e56985$export$6f4a0f769e61929;

});

parcelRegister("1KCEa", function(module, exports) {
/**
 * @generated SignedSource<<cfec91604652cc0c67750a40ff26dbd8>>
 * @relayHash de6e2bac8a58a1f311e29bca101d04f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41a183f07082b19942dc28b868628bc31ce5d5b683a639aab2d17f96750539e

var $3e6Uc = parcelRequire("3e6Uc");

const $a3b04ea0b17857c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "standardToPremiumModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "standardToPremiumModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e41a183f07082b19942dc28b868628bc31ce5d5b683a639aab2d17f96750539e",
            "metadata": {},
            "name": "standardToPremiumModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a3b04ea0b17857c4$var$node.hash = "2c7841c5e5f86c438cbec88e2db2ae41";
(0, $3e6Uc.PreloadableQueryRegistry).set($a3b04ea0b17857c4$var$node.params.id, $a3b04ea0b17857c4$var$node);
var $a3b04ea0b17857c4$export$2e2bcd8739ae039 = $a3b04ea0b17857c4$var$node;
module.exports["default"] = $a3b04ea0b17857c4$export$2e2bcd8739ae039;

});

parcelRegister("5ncWi", function(module, exports) {

let $3e99233571b675f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3e99233571b675f7$var$load("6wr18"),
    $3e99233571b675f7$var$load("dNed9"),
    $3e99233571b675f7$var$load("hUapU"),
    $3e99233571b675f7$var$load("gjVBG"),
    $3e99233571b675f7$var$load("becB8"),
    $3e99233571b675f7$var$load("adH3p"),
    $3e99233571b675f7$var$load("lRtGG"),
    $3e99233571b675f7$var$load("ffEVr"),
    $3e99233571b675f7$var$load("eWCiQ")
]).then(()=>parcelRequire('edScR'));

});

parcelRegister("fAD9L", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6xdDU = parcelRequire("6xdDU");


var $TSbNa = parcelRequire("TSbNa");

const $71b8fe84901d80f2$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $42omo.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $42omo.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $71b8fe84901d80f2$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $42omo.useRef)(1);
    const [modals, setModals] = (0, $42omo.useState)([]);
    const modalContext = (0, $42omo.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $TSbNa.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $l998X.jsx)($71b8fe84901d80f2$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}
module.exports["ModalContextProvider"] = $71b8fe84901d80f2$export$7c9538f5f3c365e9;

});

parcelRegister("TSbNa", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $645b684711965e78$export$ab57792b9b6974a6 = (0, $42omo.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});
module.exports["ModalContext"] = $645b684711965e78$export$ab57792b9b6974a6;

});

parcelRegister("7wGk4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $irOoi = parcelRequire("irOoi");


var $iP9n7 = parcelRequire("iP9n7");


var $cQDYl = parcelRequire("cQDYl");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $eyWa4 = parcelRequire("eyWa4");


var $4M6GB = parcelRequire("4M6GB");


var $TSbNa = parcelRequire("TSbNa");


var $7wYo8 = parcelRequire("7wYo8");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");

const $abc57e0f1f470075$var$emptyEntryPointParams = {};
const $abc57e0f1f470075$var$emptyEntryPointProps = {};
function $abc57e0f1f470075$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus = true }) {
    (0, $fBMbo.di)((0, $irOoi.loadEntryPoint));
    const { openModal: openModal } = (0, $42omo.useContext)((0, $TSbNa.ModalContext));
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $4M6GB.useEntryPointConfig)();
    const metricName = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $abc57e0f1f470075$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                        children: title ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $l998X.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $l998X.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $abc57e0f1f470075$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}
module.exports["ModalTrigger"] = $abc57e0f1f470075$export$fb10b32cfe19f1e;

});


//# sourceMappingURL=EditionAwarenessUpsell.52d63ee0.js.map
